import { drupalComponent } from '@nech/src/helpers/drupal-component';
import { applyExternalLinkBehavior } from '@nech/src/helpers/external-links';

(function (Drupal, $) {
  drupalComponent('nechAccordionItem', {
    selector: '.accordion-item',

    shared: {
      toggleItem: function ($el: JQuery<HTMLElement>) {
        const content = $el.find('.content');
        const icon = $el.find('.button');
        const isContentHidden = !content.is(':visible');

        $('.accordion-item').not($el).find('.accordion-trigger').attr('aria-expanded', 'false');
        $('.accordion-item .content').not(content).slideUp(400);
        $('.accordion-item .button').not(icon).removeClass('icon-rotate');

        $('.accordion-item .button').not($el.find('.button')).css('transform', '');
        content
          .slideToggle('400')
          .removeClass('hidden')
          .attr('aria-hidden', isContentHidden ? 'false' : 'true');
        icon.toggleClass('icon icon-rotate');
        $el.find('.accordion-trigger').attr('aria-expanded', isContentHidden ? 'true' : 'false');

        if ($el.find('.gc--files-list').length > 0) {
          $('.accordion-item').not($el).removeClass('bg-neutral-100').addClass('bg-neutral-50');
          $el.removeClass('bg-neutral-50').toggleClass('bg-neutral-100');
        }
        
      },
    },

    attach(context, options) {
      const self = this;
      const $elements = $(this.selector, context);

      $elements.each(function () {
        const $el = $(this);

        if ($el.data('accordion-cliked-attached')) {
          return;
        }

        // Apply external link behavior to content
        const $content = $el.find('.content');
        applyExternalLinkBehavior($content);

        $el.on('click', function (event) {
          if (
            $(event.target).closest('a').length > 0 ||
            $(event.target).closest('button').not('.accordion-trigger').length > 0
          ) {
            return;
          }
        
          self.shared.toggleItem($el);
        });
        

        $el.data('accordion-cliked-attached', true)
      });
    },
  });
})(Drupal, jQuery);
